import { HttpMethods } from '@lwt-common/http-service/HttpService';
import config from '../config.json';

export const authServiceApiFactory = (
    httpServiceApi
) => {
    const baseUrl = config.AUTHENTICATION_API_URL;

    const response = { error: undefined };
    const onFailure = error => {
        response.error = error
    };

    const login = async input => {
        response.tokens = await httpServiceApi.sendRequest(
            `${baseUrl}/login`,
            {
                emailAddress: input.emailAddress,
                password: input.password,
                clientId: input.clientId
            }, {
                method: HttpMethods.POST,
                onFailure,
                useToken: false
            }
        );
        return response;
    };

    const resetPassword = async emailAddress => {
        response.succeeded = true;
        await httpServiceApi.sendRequest(
            `${baseUrl}/reset-password`,
            { emailAddress },
            {
                onFailure,
                method: HttpMethods.POST
            });
        return response;
    };

    const getUserClients = async () => {
        response.userClients = await httpServiceApi.sendRequest(`${baseUrl}/user-clients`, null, { onFailure });
        return response;
    };

    const logout = async () => {
        response.succeeded = true;
        await httpServiceApi.sendRequest(`${baseUrl}/logout`, null, { method: HttpMethods.POST, onFailure });
        return response;
    };

    const changePassword = async (userGuid, currentPassword, newPassword) => {
        response.succeeded = true;
        await httpServiceApi.sendRequest(
            `${baseUrl}/users/${userGuid}/change-password`,
            {
                currentPassword,
                newPassword
            },
            {
                method: HttpMethods.POST,
                onFailure
            },
        );
        return response;
    };

    const refreshToken = async (clientId) => {
        response.tokens = await httpServiceApi.sendRequest(
            `${baseUrl}/refresh-token?clientId=${clientId}`,
            null,
            { onFailure }
        );
        return response;
    };

    return {
        login,
        logout,
        resetPassword,
        changePassword,
        getUserClients,
        refreshToken
    }
};